import { Component, OnInit, AfterViewInit, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

// ---------Shared--------------------------------------------
import { StudentService } from '../../shared-components/student/student.service';
import { Student } from '../../shared-components/student/student.model';
import { YearService } from '../../shared-components/year/year.service';
import { UserService } from '../../shared-components/user/user.service';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { Discipline } from '../../shared-components/student/discipline.model';
import { LoginService } from '../../shared-modules/login/login.service';
import { AriaDirective } from '../../shared-components/directives/aria.directive';
import { detailExpand } from '../../shared-components/angular-material/mat-animations';

// -------Angular Material------------------------------------
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { BehaviorLetter } from '../../counselor360/behavior/models/behavior-letter.model';
import { System } from '../../shared-components/System';
import { EForm } from '../../shared-components/e-forms/e-form.model';
import { BehaviorService } from '../../counselor360/behavior/behavior.service';
import { EFormTemplate } from '../../shared-components/e-forms/e-form-template.model';
import { EFormService } from '../../shared-components/e-forms/e-form.service';
import { EFormDataObject } from '../../shared-components/e-forms/e-formDataObject.model';
import { EFormConfiguration, enmEFormViewModes } from '../../shared-components/e-forms/e-form-config.model';
import { BehaviorLetterViewerModalComponent } from '../../counselor360/behavior/behavior-letters/behavior-letter-viewer-modal/behavior-letter-viewer-modal.component';

@Component({
    selector: 'discipline',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './discipline.component.html',
    styleUrls: ['./discipline.component.css'],
    animations: [detailExpand],
})
export class DisciplineComponent implements OnInit, AfterViewInit, OnDestroy {

    // ------------Academic History Data---------------------------
    student360YearSubscription: Subscription;
    selectedStudentSubscription: Subscription;
    selectedStudent: Student;
    disciplines: Discipline[] = [];
    // ------------Selection/Flags-----------------------------------
    selected = '0';
    V10: boolean;
    isBusy = false;
    useDisciplineEventModel: boolean;
    parentPortalDisciplineShowComments: boolean;
    isStaffMember = false;
    // ----------Angular Material------------------------------------
    angularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    columnsToDisplay: string[] = ['More', 'DateTime', 'Incident', 'Involvement', 'Action', 'ActionDate', 'Days'];
    initialSelection = [];
    allowMultiSelect = true;
    selection = new SelectionModel<any>(this.allowMultiSelect, this.initialSelection);

    // --------------LifeCycle---------------------------------------

    constructor(private studentService: StudentService,
        private yearService: YearService,
        private userService: UserService,
        private loginService: LoginService,
        private behaviorService: BehaviorService,
        private eFormService: EFormService,
        private dialog: MatDialog,
    ) {
        this.selectedStudentSubscription = studentService.selectedStudentStream$.subscribe(
            studentId => {
                this.loadStudentInfo(studentId);
            });
        this.student360YearSubscription = yearService.observableStudent360YearStream$.subscribe(
            studentYear => {
                this.getStudentDiscipline();
            }
        );

        this.angularMatData = new TylerMatTableDataSource(this.disciplines);
        this.V10 = this.userService.currentUser.V10;
        this.isStaffMember = this.userService.userType == 1;
        this.useDisciplineEventModel = this.loginService.LoginSettings.UseDisciplineEventModel;
        this.parentPortalDisciplineShowComments = this.loginService.LoginSettings.ParentPortalDisciplineShowComments;
        // ONE-5840
        // ONE-6659 12/19/19 Comments are NOT to be displayed on Parent & Student Portal.
        if (!this.V10 && this.isStaffMember) {
            this.parentPortalDisciplineShowComments = true;
        }
    }

    ngOnInit() {
        if (this.V10) {
            this.columnsToDisplay = [];
            this.columnsToDisplay = ['More', 'DateTime', 'Incident', 'Involvement', 'Action', 'ActionDate', 'Days', 'BehaviorLetter'];
        }
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {
        this.selectedStudentSubscription.unsubscribe();
        this.student360YearSubscription.unsubscribe();
    }

    // ------------Student Discipline Data---------------------------

    loadStudentInfo(studentId: number) {
        this.clearStudentData();
        this.selectedStudent = this.studentService.students.filter(function (student) { return student.Id == studentId; })[0];
        this.getStudentDiscipline();
    }

    getStudentDiscipline() {
        this.isBusy = true;

        this.angularMatData.data = [];

        setTimeout(() => {
            this.studentService.getStudentDiscipline(this.selectedStudent.Id, this.yearService.student360Year.Id, this.userService.userId).subscribe(data => {
                this.disciplines = data;
                this.disciplines.forEach(element => {
                    element.BehaviorLetter = element.BehaviorLetterId && element.BehaviorLetterId > 0 ? true : false;
                });
                this.loadStudentDiscipline();
            });
        }, 0);

    }

    private loadStudentDiscipline(): void {

        this.angularMatData.data = this.disciplines;

        setTimeout(() => {
            this.angularMatData.sort = this.sort;
        }, 0);

        this.isBusy = false;
    }

    clearStudentData() {

    }

    // ------------Aria/Accessibility---------------------------

    getAriaRow(row: Discipline): string {
        const colList: string[] = ['Date/Time',
            'Incident',
            'Involvement',
            'Action',
            'Action Date',
            'Days'];

        const dataList: string[] = [row.DateTime.toString(),
        row.Incident,
        row.Involvement,
        row.Action,
        ((row.ActionDate.toString() != '0001-01-01T00:00:00') ? new Date(row.ActionDate).toDateString() : ''),
        (row.Days != 0 ? row.Days.toString() : '')];

        return AriaDirective.concatAriaStrings(colList, dataList) + ' Expand for more details';
    }

    getAriaDetailRow(row: Discipline): string {
        const colList: string[] = ['Event',
            'Location',
            'Involving Others',
            'Reported To Police',
            'Reported by'];

        const dataList: string[] = [row.Event,
        row.Location,
        row.InvolvingOthers,
        row.ReportedToPolice,
        row.ReportedBy];

        if (this.parentPortalDisciplineShowComments) {
            if (row.EventComments != null && row.EventComments != '') {
                colList.push('Event Comment');
                dataList.push(row.EventComments);
            }
            if (row.ActionComments != null && row.ActionComments != '') {
                colList.push('Action Comment');
                dataList.push(row.ActionComments);
            }
            if (row.IncidentComments != null && row.IncidentComments != '') {
                colList.push('Incident Comment');
                dataList.push(row.IncidentComments);
            }
        }

        return AriaDirective.concatAriaStrings(colList, dataList);
    }

    // ----------Angular Material------------------------------------
    toggleExpanded(row: any) {
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }

    behaviorLetterClick(d) {
        // Get BehaviorLetter details by letterId
        const letterId = d.BehaviorLetterId;
        let includeEForm = false;
        let includePDF = false;
        let behaviorLetter: BehaviorLetter;
        let templates: EFormTemplate[];
        if (this.userService.userType == 1) {
            includeEForm = true;
        }
        else {
            includePDF = true;
        }
        this.behaviorService.getBehaviorLetters(this.yearService.defaultYear.Id, 0, letterId, 0, includeEForm, includePDF).subscribe(results => {
            if (results && results.length > 0) {
                behaviorLetter = results[0];
                // Show Letter
                if (this.userService.userType == 1) {
                    // BehaviorLetterTemplate
                    this.behaviorService.getBehaviorLetterTemplates(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID, 0).subscribe(r => {
                        templates = r;
                        this.schoolCopy(behaviorLetter, templates);
                    });
                }
                else {
                    this.parentCopy(behaviorLetter);
                }
            }
        });

    }

    schoolCopy(behaviorLetter: BehaviorLetter, eFormTemplate: EFormTemplate[]) {

        const eForm: EForm = new EForm;

        eForm.FormData = behaviorLetter.FormData;
        eForm.Student_ID = behaviorLetter.StudentId;
        const template: EFormTemplate = eFormTemplate.find(o => o.ID == behaviorLetter.TemplateId);

        this.eFormService.selectedForm = eForm;
        try {
            this.eFormService.selectedFormData = JSON.parse(eForm.FormData);
        } catch (err) {
            this.eFormService.selectedFormData = new EFormDataObject();
        }
        const vConfig = new EFormConfiguration();
        vConfig.ViewMode = enmEFormViewModes.Form;
        vConfig.ShowSubmittedBy = false;
        vConfig.DisableSubmission = true;
        vConfig.ReadOnly = true;
        vConfig.UseInstance = false;
        vConfig.Title = behaviorLetter.TemplateName;
        const viewFormDialog = this.dialog.open(BehaviorLetterViewerModalComponent, {
            disableClose: true,
            height: '100vh',
            data: {
                config: vConfig,
                template: template
            }
        });
        // }));
    }

    parentCopy(behaviorLetter: BehaviorLetter) {
        const pdfName: string = behaviorLetter.TemplateName + ' - ' + behaviorLetter.FirstName + ' ' + behaviorLetter.LastName;

        if (!this.V10) {
        }
        else {
            System.viewFileFromBase(behaviorLetter.base64PDF, 'pdf', pdfName + '.pdf');
        }
    }
}
